export default __webpack_public_path__ + "static/media/no-properties.f815ec7d.png";